module.exports = __webpack_public_path__ + "img/preview-16.103c33d1.png";